module.exports = __webpack_public_path__ + "static/img/13e.e1a1679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/13e.jpg
// module id = JMHL
// module chunks = 0